import axios from "axios";

const apiVeloPro = axios.create({
  baseURL: process.env.REACT_APP_VELOPRO_URL || "http://localhost:8888",
});

export default apiVeloPro;
